import React from "react";
// Icon Imports
import {
  MdOutlineShoppingCart,
  MdBarChart,
  MdPerson,
  MdLock
} from "react-icons/md";
import { CreditCardOutlined,  
GlobalOutlined, AuditOutlined 
} from '@ant-design/icons';

import { 
	FaUsersRectangle,
	FaBuildingColumns, FaWallet,
	FaFileInvoiceDollar, FaGear,
	FaShieldHalved, 
	FaUsersGear
} from "react-icons/fa6";

import { LuCalendar, 
	LuUsers, LuGraduationCap, LuAward,
} from "react-icons/lu";

import { FileChartColumnIncreasing, House, Headset } from "lucide-react";

import SignIn from "views/auth/SignIn";
import Dashboard from "views/console/default";
import Profile from "views/admin/profile";
import Payrolls from "views/console/payrolls";
import ViewReport from "views/console/reports/view";

import MyPayslip from "views/private/my-payslip";

import employeeRoutes from "views/console/employees/routes";
import payrollRoutes from "views/console/payrolls/routes";
import salaryAdditionRoutes from "views/console/salary-additions/routes";
import salaryAdjustmentRoutes from "views/console/salary-adjustments/routes";
import salaryDeductionRoutes from "views/console/salary-deductions/routes";
import clientRoutes from "views/console/clients/routes";
import reportsRoutes from "views/console/reports/routes";
import holidaysRoutes from "views/console/holidays/routes";
import finalPayRoutes from "views/console/final-pays/routes";
import accessRightsRoutes from "views/console/access-rights/routes";
import userRoutes from "views/console/users/routes";
import accessGroupsRoutes from "views/console/access-groups/routes";
import modulesRoutes from "views/console/modules/routes";
import { MODULE_ACCESS_MANAGEMENT_MENU, 
	MODULE_DASHBOARD, MODULE_FINAL_PAYS, MODULE_FINANCE, 
	MODULE_INVOICES, MODULE_MYPAYSLIPS, MODULE_PAYCODES, 
	MODULE_PAYROLL_MENU, MODULE_SETTINGS_MENU, 
	MODULE_TEAM_MENU, 
	MODULE_TIMEKEEPING,
	MODULE_RECRUITMENT,
	MODULE_TRAINING,
	MODULE_TRAINING_AND_DEV,
	MODULE_TIMECARDS, MODULE_REPORTS
} from "variables/constants";
import timeCardRoutes from "views/console/time-cards/routes";
import leavesRoutes from "views/console/leaves/routes";
import overtimesRoutes from "views/console/overtimes/routes";
import Payslips from "views/console/payrolls/payslips";
import trainingModulesRoutes from "views/console/training-modules/routes";
import trainingClassRoutes from "views/console/training-classes/routes";
import trainingModuleRequestRoutes from "views/console/training-module-requests/routes";
import trainingOverviewRoutes from "views/console/training-overviews/routes";
import jobPostRoutes from "views/console/job-posts/routes";
import jobRoleRoutes from "views/console/job-roles/routes";
import jobRoleRequestRoutes from "views/console/job-role-requests/routes";
import myTrainingCourseRoutes from "views/console/training-courses/routes";
import trainingCertificationRoutes from "views/console/training-certifications/routes";
import browseTrainingRoutes from "views/console/training-classes/browse-trainings/routes";
import recruitmentRoutes from "views/console/recruitment/routes";
import teamOverviewRoutes from "views/console/team-managements/routes"
import performanceReviewRoutes from "views/console/team-managements/performance-reviews/routes"
import employeeDetailRoutes from "views/console/team-managements/employee-details/routes";
import performanceImprovementRoutes from "views/console/team-managements/performance-improvement/routes";
import teamUpskillRoutes from "views/console/training-courses/team-upskill/routes";
import attendanceOverviewRoutes from "views/console/attendances/routes";
import leavesRequestRoutes from "views/console/attendances/leave-requests/routes";
import teamAbsencesRoutes from "views/console/attendances/team-absences/routes";
import productivityRoutes from "views/console/team-managements/productivity/routes";
import myAttendanceRoutes from "views/console/attendances/employee-attendances/routes";
import performanceGoalsRoutes from "views/console/performance-goals/routes";
import myAwardRoutes from "views/console/employee-awards/routes";
import hyvidPointRoutes from "views/console/employee-awards/hyvid-points/routes";
import recognitionWallRoutes from "views/console/employee-awards/recognitions-wall/routes";
import itSupportRoutes from "views/console/support/routes"
import hyvidAwardRoutes from "views/console/employee-awards/hyvid-awards/routes";
import hyvidRewardRoutes from "views/console/employee-awards/hyvid-rewards/routes";
import hrSupportRoutes from "views/console/support/hr-support/routes";
import faqRoutes from "views/console/support/faq/routes";
import inboxRoutes from "views/console/inbox/routes";
import profileRoutes from "views/console/profiles/routes";
import storeRoutes from "views/console/hyvid-store/routes";
import advancedReportRoutes from "views/console/reports/generate-reports/routes";
import partnerServicetRoutes from "views/console/support/partner-service/routes";
import employeeDocumentsRoutes from "views/console/documents/routes";
import overtimesRequestRoutes from "views/console/attendances/overtime-requests/routes";
//import systemCheckRoutes from "views/console/system-check/routes";
//import userGuideRoutes from "views/console/user-guide/routes";



const routes = [
	{
		name: "Sign In",
	    layout: "/auth",
	    path: "sign-in",
	    icon: <MdLock className="icon-item" />,
	    component: <SignIn />,
	    isMainMenu:false,
  	},
  	{
    	name: "Profile",
    	layout: "/admin",
    	path: "profile",
    	icon: <MdPerson className="icon-item" />,
    	component: <Profile />,
    	isMainMenu:false,
  	},
  	{
    	name: "Dashboard",
	    layout: "/console",
	    path: "dashboard",
	    icon: <House className="icon-item" />,
	    component: <Dashboard />,
	    isMainMenu:true,
		level:5,
		moduleId: MODULE_DASHBOARD,
  	},
	...inboxRoutes,
	...profileRoutes,
  	{
	    name: "Team",
	    layout: "/console",
	    path: "#",
	    icon: <FaUsersRectangle className="icon-item" />,
	    component: null,
	    isMainMenu:true,
		level:3,
		moduleId: MODULE_TEAM_MENU,
	    children: [
			...clientRoutes,
			...employeeRoutes,
		],
  	},
	{
	    name: "People Management",
	    layout: "/console",
	    path: "#",
	    icon: <LuUsers className="icon-item" />,
	    component: null,
	    isMainMenu:true,
		level:4,
		moduleId: MODULE_TEAM_MENU,
	    children: [
			...teamOverviewRoutes,
			...employeeDetailRoutes,
			...recruitmentRoutes,
			...performanceReviewRoutes,
			...performanceImprovementRoutes,
			...productivityRoutes,
		],
  	},
	{
	    name: "Timekeeping",
	    layout: "/console",
	    path: "#",
	    icon: <LuCalendar className="icon-item" />,
	    component: null,
	    isMainMenu:true,
		level:5,
		moduleId: MODULE_TIMEKEEPING,
	    children: [
			...myAttendanceRoutes,
			...timeCardRoutes,
			...overtimesRoutes,
			...leavesRoutes,
			...attendanceOverviewRoutes,
			...leavesRequestRoutes,
			...teamAbsencesRoutes,
			...overtimesRequestRoutes,
		],
  	},
	{
	    name: "Learning & Development",
	    layout: "/console",
	    path: "#",
	    icon: <LuGraduationCap className="icon-item" />,
	    component: null,
	    isMainMenu:true,
		level:5,
		moduleId: 0,
	    children: [
			...trainingOverviewRoutes,
			...teamUpskillRoutes,
			...trainingClassRoutes,
			...trainingModulesRoutes,
			...trainingModuleRequestRoutes,
			...myTrainingCourseRoutes,
			...browseTrainingRoutes,
			...trainingCertificationRoutes,
		],
  	},
	// {
	//     name: "Training & Development",
	//     layout: "/console",
	//     path: "#",
	//     icon: <LuGraduationCap className="icon-item" />,
	//     component: null,
	//     isMainMenu:true,
	// 	level:5,
	// 	moduleId: MODULE_TRAINING_AND_DEV,
	//     children: [
			
	// 	],
  	// },
	{
	    name: "Recognition & Rewards",
	    layout: "/console",
	    path: "#",
	    icon: <LuAward className="icon-item" />,
	    component: null,
	    isMainMenu:true,
		level:5,
		moduleId: 0,
	    children: [
			...myAwardRoutes,
			...hyvidPointRoutes,
			...recognitionWallRoutes,
			...hyvidAwardRoutes,
			...hyvidRewardRoutes,
			...storeRoutes,
		],
  	},
  	{
	    name: "Payroll",
	    layout: "/console",
	    path: "#",
	    icon: <FaWallet className="icon-item" />,
	    component: null,
	    isMainMenu:false,
		level:3,
		moduleId: MODULE_PAYROLL_MENU,
	    children: [
			...payrollRoutes,		  
		  	...salaryAdjustmentRoutes,		
		  	...salaryDeductionRoutes,  			  	
		  	...salaryAdditionRoutes,
			...finalPayRoutes,
	  	]
  	},
	{
	    name: "Finance",
	    layout: "/console",
	    path: "#",
	    icon: <FaBuildingColumns className="icon-item" />,
	    component: null,
	    isMainMenu:true,
		level:3,
		moduleId: MODULE_FINANCE,
	    children: [
			...payrollRoutes,		  
		  	...salaryAdjustmentRoutes,		
		  	...salaryDeductionRoutes,  			  	
		  	...salaryAdditionRoutes,
			...finalPayRoutes,
			{
				name: "Invoices",
				layout: "/console",
				path: "invoices",
				icon: <FaFileInvoiceDollar className="icon-item"/>,
				component: <Payrolls />,
				isMainMenu:true,
				level:3,
				moduleId: MODULE_INVOICES,
			},
	  	]
  	},
	{
	    name: "Recruitment",
	    layout: "/console",
	    path: "#",
	    icon: <FaUsersGear className="icon-item" />,
	    component: null,
	    isMainMenu:true,
		level:3,
		moduleId: MODULE_RECRUITMENT,
	    children: [
			...jobRoleRoutes,
			...jobRoleRequestRoutes,
			...jobPostRoutes,
	  	]
  	},
	{
	    name: "Analytics & Reports",
	    layout: "/console",
	    path: "#",
	    icon: <FileChartColumnIncreasing className="icon-item" />,
	    component: null,
	    isMainMenu:true,
		level:3,
		moduleId: MODULE_REPORTS,
	    children: [
			...reportsRoutes,
			...advancedReportRoutes,

	  	]
  	},

	
	...performanceGoalsRoutes,
	{
	    name: "Settings",
	    layout: "/console",
	    path: "#",
	    icon: <FaGear className="icon-item"/>,
	    component: null,
	    isMainMenu:true,
		level:3,
		moduleId: MODULE_SETTINGS_MENU,
	    children: [
			...holidaysRoutes,
		  	{
			    name: "Paycodes",
			    layout: "/console",
			    path: "paycodes",
			    component: <ViewReport/>,
			    icon: <AuditOutlined className="icon-item"/>,
			    isMainMenu:false,
				level:3,
				moduleId: MODULE_PAYCODES,
		  	},
		  	{
			    name: "System Parameters",
			    layout: "/console",
			    path: "system-parameters",
			    component: <ViewReport/>,
			    icon: <GlobalOutlined className="icon-item"/>,
			    isMainMenu:false,
				level:2,
				moduleId: 0,
		  	},
		]
  	},
  	{
	    name: "Access Management",
	    layout: "/console",
	    path: "#",
	    icon: <FaShieldHalved className="icon-item"/>,
	    component: null,
	    isMainMenu:true,
		level:2,
		moduleId: MODULE_ACCESS_MANAGEMENT_MENU,
	    children: [
			...userRoutes,
			...accessGroupsRoutes,
			...accessRightsRoutes,
			...modulesRoutes,
		]
  	},
	...employeeDocumentsRoutes,
	{
    	name: "My Payslips",
	    layout: "/console",
	    path: "my-payslips",
	    icon: <CreditCardOutlined className="icon-item" />,
	    component: <Payslips />,
	    isMainMenu:true,
		level:5,
		moduleId: MODULE_MYPAYSLIPS,
  	},
  	{
	    name: "View My Payslip",
	    layout: "/private",
	    icon: <CreditCardOutlined className="icon-item" />,
	    path: "/my-payslip/:payrollId/:empId/:hash",
	    component: <MyPayslip />,
	    isMainMenu:false,
  	},
	{
	    name: "Support & Help",
	    layout: "/console",
	    path: "#",
	    icon: <Headset className="icon-item" />,
	    component: null,
	    isMainMenu:true,
		level:5,
		moduleId: 0,
	    children: [
			...itSupportRoutes,
			...hrSupportRoutes,
			...faqRoutes,
			...partnerServicetRoutes,
		],
  	},
];

export default routes;
